import React from 'react'
import ContentContainer from '../components/ContentContainer'
import * as DataUtils from '../util/DataUtils'

export default class ContentLoader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentDidMount() {
    this.setup()
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps !== this.props) {
      this.setup()
    }
    return true
  }
  setup() {
    const content = this.props
    if (typeof(content)==='object'&&content!==null) {
      const id = content[DataUtils.ID]
      const type = content[DataUtils.TYPE]
      const slug = content[DataUtils.SLUG]
      const dataPath = `/data`
      const contentsPath = `${dataPath}/contents/${type}`
      const fileName = `${id}.json`
      const filePath = `${contentsPath}/${fileName}`
      DataUtils.fetchObject(filePath, content=>{
        if (typeof(content)==='object'&&content!==null) {
          if (content[DataUtils.SLUG]===undefined) {
            if (typeof(slug)==='string'&&slug.length>0) {
              content[DataUtils.SLUG] = slug
            }
          }
          this.setState({content:content})
        }
      })
    }
  }
  render() {
    if (typeof(this.state.content)==='object'&&this.state.content!==null) {
      return (
        <ContentContainer {...this.state.content}
          className={this.props.className}
          viewMode={this.props.viewMode}
          location={this.props.location}
        />
      )
    }
    return (
      <div></div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentLoader.js